import { css } from 'lit';

export const appNavStyles = css`
  :host {
    display: block;
    margin-bottom: 2rem;
  }

  nav {
    display: flex;
    gap: 1.5rem;
    border-bottom: 1px solid var(--border-subtle, #eeeee7);
    padding-bottom: 0.5rem;
  }

  button {
    background: none;
    border: none;
    font-family: var(--font-sans);
    font-size: 0.95rem;
    font-weight: 500;
    color: var(--text-muted, #7c7c75);
    cursor: pointer;
    padding: 0.2rem 0;
    position: relative;
    transition: color 0.15s ease;
  }

  button:hover {
    color: var(--text-primary, #1a1a18);
  }

  button.active {
    color: var(--text-primary, #1a1a18);
    font-weight: 600;
  }

  button.active::after {
    content: '';
    position: absolute;
    bottom: -0.55rem;
    left: 0;
    width: 100%;
    height: 2px;
    background-color: var(--accent-color, #245590);
  }
`;
